import { List } from "./ResumePrimitives";

export function AchievementsAndAwards() {
  return (
    <List
      items={[
        "National Merit Scholarship Finalist",
        "Northrop Grumman Corporate Sponsor Scholarship Winner",
      ]}
    />
  );
}
